import React from "react";

import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import "../styles/components/TemplateTypeDropDown.scss";

const SingleSelectList = ({ data, open, handleClose, handleChange }) => {
  return (
    <div className="single-select-no-search">
      <MenuList autoFocusItem={open}>
        <div>
          {data?.map((option, index) => {
            const normalizedOption =
              typeof option === "string"
                ? {
                    id: `user-action-${index}`,
                    label: option,
                    value: option,
                    disabled: false,
                  }
                : {
                    id: option?.id || `user-action-${index}`,
                    label: option?.label || option?.value || "",
                    value: option?.value || option?.label || "",
                    disabled: Boolean(option?.disabled),
                  };

            return (
              <MenuItem
                className={`menu-item-template-type ${
                  normalizedOption.disabled ? "menu-item-template-type--disabled" : ""
                }`}
                name="templatetype"
                value={normalizedOption.value}
                key={normalizedOption.id}
                disabled={normalizedOption.disabled}
                onClick={() => {
                  if (normalizedOption.disabled) return;
                  if (typeof handleClose === "function") {
                    handleClose();
                  }
                  handleChange(normalizedOption.value);
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                }}
                onBlur={(e) => e.preventDefault()}
              >
                {normalizedOption.label}
              </MenuItem>
            );
          })}
        </div>
      </MenuList>
    </div>
  );
};

export default SingleSelectList;
